welcomeBack:
    en: Welcome back
    ru: Добро пожаловать
rememberThisBrowser:
    en: Remember this browser
    ru: Запомнить браузер
twoFactorAuth:
    en: Two Factor Authentication
    ru: Двухфакторная авторизация
twoFactorAuthDescription:
    en: Each time you log in, you’ll use a one-time code in addition to your password
    ru: Каждый раз при авторизации Вы будете вводить одноразовый пароль в дополнении к обычному паролю
codeIsInvalid:
    en: Please enter a valid code
    ru: Пожалуйста, введите корректный код
pleaseWait:
    en: Please wait...
    ru: Пожалуйста, подождите...
congrats:
    en: Congratulations!
    ru: Поздравляем!
twoFactorAuthEnabled:
    en: Two Factor Authentication is now enabled for this account
    ru: Дввухфакторная авторизация активирована для этого аккаунта
continue:
    en: Continue
    ru: Продолжить
skip:
    en: Skip
    ru: Пропустить
setItUp:
    en: Set it Up
    ru: Настроить
back:
    en: Back
    ru: Назад
instructionLine1:
    en: Install Google Authenticator app or use another Authenticator app of your choice
    ru: Установите приложение Google Authenticator или другое подобное на ваш выбор
instructionLine2:
    en: Open the app and select add
    ru: Откройте приложение и выберите добавить
instructionLine3:
    en: Scan the QR code OR enter the code into your Authenticator app
    ru: Отсканируйте QR код или введите код в вашем Authenticator приложении
instructionLine4:
    en: Enter the 6 digit one time password generated by your Authenticator app
    ru: Введите 6-ти значный одноразовый пароль, полученный из вашего Authenticator приложения
support:
    en: Contact <a href="mailto:support@maxoptra.com">support@maxoptra.com</a> if you are having trouble logging in
    ru: Свяжитесь с <a href="mailto:support@maxoptra.com">support@maxoptra.com</a> если у вас проблемы с авторизацией
setupTwoFactorAuth:
    en: Set up Two Factor Authentication
    ru: Настройка двухфакторной авторизации
INVALID_LOGIN:
    en: 'Invalid login or password'
    es: 'Inicio de sesión o contraseña inválido'
    fr: 'Identifiant ou mot de passe invalide'
    pt: 'Senha ou início de sessão inválido'
    ru: 'Неверный логин или пароль'
UNKNOWN_ERROR:
    en: 'Unknown error'
    es: 'Error desconocido'
    fr: 'Erreur inconnue'
    pt: 'Erro desconhecido'
    ru: 'Неизвестная ошибка'
ACCOUNT_SUSPENDED:
    en: 'Your account has been suspended'
    es: 'Su cuenta ha sido suspendida'
    pt: 'A sua conta está suspensa'
    ru: 'Ваш аккаунт был приостановлен'
WRONG_LICENSE:
    en: 'Your License is invalid'
    es: 'Su licencia es inválida'
    pt: 'A sua licença não é válida'
    ru: 'Ваша лицензия недействительна'
INVALID_IP:
    en: 'Your IP is blocked'
    es: 'Su IP está bloqueada'
    pt: 'Acesso negado por ip'
    ru: 'Ваш IP заблокирован'
TRIAL_PERIOD_IS_NOT_STARTED_YET:
    en: 'Your trial period has not started yet'
    es: 'Su periodo de prueba no se ha iniciado todavía'
    pt: 'O seu período experimental ainda não começou'
    ru: 'Ваш тестовый период еще не начался'
IN_MAINTENANCE:
    en: 'Server undergoing maintenance'
    es: 'Servidor en mantenimiento'
    pt: 'Servidor em manutenção'
    ru: 'На сервере проводится техническое обслуживание'
INVALID_HASH:
    en: 'Your link is broken'
    es: 'Su enlace está roto'
    pt: 'A ligação internet não funciona'
    ru: 'Cсылка не работает'
PASSWORDS_NOT_EQUAL:
    en: 'Passwords do not match'
    es: 'Las contraseñas no coinciden'
    pt: 'As senhas não coincidem'
    ru: 'Пароли не совпадают'
SHORT_PASSWORD:
    en: 'Passwords must be at least 8 characters'
    es: 'La contraseña debe tener como mínimo 8 caracteres'
    fr: 'Passwords must be at least 8 characters'
    pt: 'A senha deve ter pelo menos 8 carateres'
    ru: 'Пароль должен быть не менее 8 символов'
LINK_EXPIRED:
    en: 'Your link has expired'
    es: 'Tu enlace ha expirado'
    fr: ''
    pt: 'O link expirou'
    ru: 'Срок действия ссылки истек'
2FA_INVALID_CODE:
    en: Please enter a valid code
    ru: Пожалуйста, введите корректный код
2FA_ALREADY_ACTIVATED:
    en: 2FA is already set for user
    ru: Двухфакторная авторизация уже настроена для пользователя
loginPlaceholder:
    en: 'Login'
    ru: 'Войти'
    es: 'Inicio sesión'
    pt: 'Entrar'
passwordPlaceholder:
    en: 'Password'
    ru: 'Пароль'
    es: 'Contraseña'
    pt: 'Senha'
forgot:
    en: 'Forgot your password?'
    ru: 'Забыли пароль?'
    es: '¿Te has olvidado de la contraseña?'
    pt: 'Esqueceu a sua senha?'
logIn:
    en: 'Log in'
    ru: 'Войти'
    es: 'Inicio sesión'
    pt: 'Entrar'
passwordSent:
    en: 'Password reset'
    ru: 'Сброс пароля'
    es: 'Contraseña reseteada'
    pt: 'Redefinir senha'
passwordSentMessage:
    en: 'The reset password link has been sent to your email address.'
    ru: 'Ссылка для восстановления доступа к аккаунту была отправлена на Ваш почтовый адрес.'
    es: 'El enlace de restablecimiento de la contraseña ha sido enviado a su dirección de correo electrónico.'
    pt: 'O link para redefinir a sua senha foi enviado para o seu E-mail.'
resetPassword:
    en: 'Reset password'
    ru: 'Сбросить пароль'
    es: 'Resetear la contraseña'
    pt: 'Redefinir senha'
forgotPasswordMessage:
    en:
        'Please enter your login and click "Reset password". The system will generate a reset password link and send it
        to your registered email address. You can change the password on your next log in.'
    ru:
        'Введите Ваш Логин пользователя и нажмите кнопку "Сбросить пароль". После этого на Ваш почтовый адрес будет
        отправлена ссылка для сброса пароля. Перейдя по этой ссылке, Вы сможете задать новый пароль.'
    es:
        'Por favor ingrese su nombre de usuario y haga clic en "Restablecer contraseña". El sistema generará un enlace
        para restablecer la contraseña y lo enviará a su dirección de correo electrónico registrada. Puede cambiar esta
        contraseña la próxima vez que inicie la sesión'
    pt:
        'Por favor digite o seu código de Utilizador e clique em “Reiniciar a senha”. O sistema irá gerar um link para
        redefinir a sua senha, que será enviado para o seu E-mail registado. Poderá alterar a senha da próxima vez que
        entrar.'
forgotPassword:
    en: 'Password reset'
    ru: 'Форма восстановления пароля'
    es: 'Contraseña olvidada?'
    pt: 'Esqueceu a sua senha'
newPassword:
    en: 'New password'
    es: 'Nueva contraseña'
    ru: 'Новый пароль'
    pt: 'Nova senha'
newPasswordConfirm:
    en: 'Confirm new password'
    es: 'Confirmar nueva contraseña'
    ru: 'Подтвердите пароль'
    pt: 'Confirme a nova senha'
changePassword:
    en: 'Change password for'
    es: 'Cambiar la contraseña para'
    ru: 'Задать новый пароль для'
    pt: 'Mudar senha para'
passwordRule:
    en: 'Password must be at least 8 characters'
    es: 'La contraseña debe tener al menos 8 caracteres'
    ru: 'Длина пароля должна быть не менее 8 символов'
    pt: 'A senha deve ter pelo menos 8 carateres'
changeAndLogin:
    en: 'Change & Log in'
    ru: 'Сохранить и Войти'
    es: 'Cambiar & Inicio sesión'
    pt: 'Mudar & Entrar'
sessionExpired:
    en: 'Your current session is expired. Please, log in again.'
    es: 'Tu session actual ha expirado. Por favor, iniciar session otra vez.'
    ru: 'Ваша сессия устарела. Авторизуйтесь, чтобы приступить к работе.'
    pt: 'log in again.'
linkIsExpired:
    en: 'Invalid link! Contact our support team.'
    ru: 'Недействительная ссылка! Обратитесь в службу поддержки.'
    pt: 'Link inválido! Por favor contacte a nossa equipa de suporte'
linkToLogIn:
    en: 'Click here to log in'
    ru: 'Нажмите сюда чтобы войти в систему'
    pt: 'Clique aqui para log in'
